export enum SynchronizeStep {
  Confirm,
  GetReady,
  InProgress,
  Finished,
}

export interface SynchronizeStatus {
  syncStep: SynchronizeStep;
  queuedCount: number;
  syncedCount: number;
  rejectedCount: number;
}
